window.Sparkle ??= {};
window.Sparkle.SpotlightSearch ??= {};

Sparkle.SpotlightSearch.ResultHighlighter = class ResultHighlighter {
  constructor(phrases, itemProperties, options) {
    this.highlight = this.highlight.bind(this);
    this._generateRegexp = this._generateRegexp.bind(this);
    this._phrasesForRegexp = this._phrasesForRegexp.bind(this);
    this.phrases = phrases;
    this.itemProperties = itemProperties;
    this.options = jQuery.extend(
      {
        ignoredPhraseDelimiters: null, // Treat these characters as if they were not present in the query string
        ignoredTargetDelimiters: null, // Treat these characters as if they were no present in the target property value
        minPhraseLength: 1, // Don't highlight phrases shorter than this length
      },
      options,
    );

    this.ignoredPhraseDelimiterRegexp = new RegExp(`[${this.options.ignoredPhraseDelimiters}]`, "g");
    this.ignoredTargetDelimiterTemplate = `[${this.options.ignoredTargetDelimiters}]*`;
    this.regexp = this._generateRegexp();
  }

  highlight(item) {
    return jQuery.each(this.itemProperties, (_, prop) => {
      if (item[prop]) {
        return (item[prop] = item[prop].replace(this.regexp, "<mark>$1</mark>"));
      }
    });
  }

  // PRIVATE

  _generateRegexp() {
    return new RegExp("(" + this._phrasesForRegexp().join("|") + ")", "ig");
  }

  _phrasesForRegexp() {
    return jQuery.map(this.phrases, (phrase) => {
      phrase = jQuery.trim(phrase);
      if (phrase.length < this.options.minPhraseLength) {
        return;
      }

      // Remove ignored query characters
      if (this.options.ignoredPhraseDelimiters) {
        phrase = phrase.replace(this.ignoredPhraseDelimiterRegexp, "");
      }

      // Modify individual characters
      let characters = phrase.split("");
      characters = jQuery.map(
        characters,
        (
          character, // escape RegExp characters
        ) => character.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
      );

      // Allow ignored target characters to exist between every character in the match
      if (this.options.ignoredTargetDelimiters) {
        phrase = characters.join(this.ignoredTargetDelimiterTemplate);
      }

      return phrase;
    });
  }
};
